@if (activeBlock()) {
  <div class="conditional__container">
    <div class="conditional__title">
      <span class="conditional__main-title fs__lg fw__500">Conditional Block Logic</span>
      <span class="conditional__sub-title fs__md">Specify below when this block will be visible:</span>
    </div>
    <div class="conditional__content">
      @if (blockNotAllowConditions$()) {
        <p class="conditional__no-condition-possible fs__md fw__400" data-testid="block-conditions-empty-message">{{ emptyBlockMessage$() }}</p>
      } @else {
        @if (previousQuestions$().length > 0) {
          <div class="conditional__condition-card">
            <div class="eiq-id-badge primary">
              <fa-icon [icon]="faCodeBranch"></fa-icon>
              <span>{{ activeBlock().value.id }} is shown only if</span>
            </div>
            <empathy-conditions-block
              [conditions]="activeBlock().get('visibleWhen').value"
              [isEditing]="isEditing$()"
              [previousQuestions]="previousQuestions$()"
              (save)="onSave($event)"
              (cancel)="isEditing$.set(false)"
              (addMore)="isEditing$.set(true)"
              (remove)="onRemoveCondition($event)"
            ></empathy-conditions-block>
          </div>
        } @else {
          <p class="conditional__no-condition-possible fs__md fw__400">There are no previous questions to set a condition</p>
        }
      }
    </div>
  </div>
}
